import { useMemo } from 'react'
import type { ExtractionRun } from '@/services/api/cases'
import { type StatusFilter, statusFilterOf } from '../extraction-run-format'

/** Derives the per-status counts and the sorted/filtered run list for the
 *  pipelines view (running first, then newest). */
export function useExtractionRunsView(runs: ExtractionRun[], filter: StatusFilter) {
  const counts = useMemo(() => {
    const c = { all: runs.length, running: 0, complete: 0, partial: 0, failed: 0 }
    for (const r of runs) c[statusFilterOf(r)] += 1
    return c
  }, [runs])

  const filteredRuns = useMemo(() => {
    const sorted = [...runs].sort((a, b) => {
      if (a.status === 'running' && b.status !== 'running') return -1
      if (b.status === 'running' && a.status !== 'running') return 1
      return new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
    })
    if (filter === 'all') return sorted
    return sorted.filter(r => statusFilterOf(r) === filter)
  }, [runs, filter])

  return { counts, filteredRuns }
}
